export default "__VITE_ASSET__DIQEEg5n__"